import { css, Theme } from '@emotion/react'
import { alpha } from '@mui/material'
import { columnChartClasses } from 'components/ColumnChart'
import { CHART_HEIGHT } from '../styles'

export const headingWrapper = (theme: Theme) => css`
  ${theme.breakpoints.down(1024)} {
    row-gap: 22px;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const chartWrapper = css`
  position: relative;
`

export const chart = (theme: Theme) => css`
  padding: 13px 0 12px 12px;
  height: ${CHART_HEIGHT}px;

  .${columnChartClasses.oxValue} {
    white-space: nowrap;
  }

  ${theme.breakpoints.down(768)} {
    .${columnChartClasses.oy} {
      height: calc(100% - 27px);
    }

    .${columnChartClasses.chartContainer} {
      gap: 9px 40px;

      padding: 10px 20px 0;
    }
  }
`

export const column = (theme: Theme) => css`
  justify-self: center;
  height: 100%;
  width: 100%;
  min-width: 53px;
  max-width: 53px;
  position: relative;
  overflow: hidden;

  ${theme.breakpoints.down(1024)} {
    width: 28px;
    min-width: 28px;
  }

  ${theme.breakpoints.down(768)} {
    min-width: 28px;
  }
`

export const item = (value: number, isCorrect: boolean) => (theme: Theme) =>
  css`
    height: ${value}%;
    width: 100%;
    position: absolute;
    bottom: 0;
    background: ${isCorrect ? theme.colors.accent : alpha(theme.colors.accent, 0.2)};
    backdrop-filter: blur(2px);
    border-radius: 8px 8px 0 0;

    :before {
      content: '';
      position: absolute;
      z-index: -1;
      inset: 0;

      padding: 1px;
      border-radius: 8px 8px 0 0;

      background: linear-gradient(to bottom, ${alpha(theme.colors.white, 0.15)}, ${alpha(theme.colors.white, 0)});
      mask: linear-gradient(#000 0 0) exclude, linear-gradient(#000 0 0) content-box;
    }
  `

export const legend = css`
  display: flex;
  gap: 14px;
`

export const legendItem = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: 4px;

  color: ${theme.typographyColors.typographyTwo};
  font-weight: 500;
  font-size: 14px;
`

export const dot = (isCorrect: boolean) => (theme: Theme) =>
  css`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${isCorrect ? theme.colors.accent : alpha(theme.colors.accent, 0.25)};
  `

export const emptyItem = (theme: Theme) => css`
  position: absolute;
  bottom: 0;

  height: 100%;
  width: 100%;
  border-radius: 8px 8px 0 0;
  border: 1px solid ${alpha(theme.colors.white, 0.15)};
  border-bottom: none;

  background: ${theme.colors.backgroundOne};
`

export const dummyItem = (value: number) =>
  css`
    height: ${value}%;
    width: 100%;
    position: absolute;
    bottom: 0;
  `

export const growAnimation = (index: number) => css`
  animation: grow 800ms cubic-bezier(0.75, 0, 0.16, 0.89) both;
  animation-delay: ${index * 100}ms;

  @keyframes grow {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`

export const chartCardSkeleton = (theme: Theme) => css`
  min-height: 265px;
  width: 100%;
  border-radius: 12px;

  ${theme.breakpoints.down(768)} {
    min-height: 297px;
  }
`

export const averageStatsSkeleton = (theme: Theme) => css`
  min-height: 144px;
  width: 100%;
  border-radius: 12px;

  ${theme.breakpoints.down(768)} {
    min-height: 267px;
  }
`
